import { ListLabelType } from 'utils/types'
import { DropdownOptionType } from 'utils/types/inputs'

export const createLabelDropdownValues = (labels: ListLabelType[]): DropdownOptionType[] =>
  labels.map(({ id, name, color }) => ({ color, label: name, value: `${id}` }))
